/**
 * 防抖动
 * 
 * @file   debounce
 * @author author-name(lhb 1301465186@qq.com)
 */

/**
 * 防抖动函数
 *
 * @export
 * @param {*} func 监听函数
 * @param {*} delay 间隔值
 * @returns 
 */
export function debounce(func, delay) {
  let timer
  return function(...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}
